<template>
  <div class="ProductInfo">
    <full-page :options="options3" ref="fullpage">
      <div class="section one">
        <h3>
          <div class="one-text">健身房智能管理软件</div>
          <div class="one-text1">在线预约&管理营销系统</div>
          <div class="more" active-class="active" @click="showBtn">免费试用</div>
        </h3>
        <!-- <p>为你精准推荐健身计划，助你更快达成健身目的</p> -->
        <img src="../assets//image/indexp1.png" alt="" class="one-img">
      </div>

      <div class="section two">
        <h3>选择Ragana</h3>
        <p class="p">助您精准覆盖会员管理流程，轻松解决运营难题</p>
        <img src="../assets//image/indexp2.png" alt="" class="two-img">
      </div>
      <div class="section five">
        <h3>微信小程序<br>
          助力场馆轻松获客拉新</h3>
        <img class="fRight" src="../assets/image/indexp3.png" alt="">
      </div>
      <FooterVue class="section"></FooterVue>
    </full-page>

    <dialogBox class="section" v-if="showdialogFormVisible" @closeBox="closeBox"
      :showdialogFormVisible="showdialogFormVisible"></dialogBox>
  </div>
</template>

<script setup>
// location.reload()
import { reactive, ref, defineEmits } from 'vue';
import FooterVue from '../components/FooterVue.vue';
import dialogBox from '../components/dialogBox.vue';
const changeColor = defineEmits(['changeColor']);
changeColor('changeColor', '')
const showdialogFormVisible = ref(false)

function showBtn(){
  showdialogFormVisible.value = true
  fullpage.value.api.setAllowScrolling(false)
}
function closeBox() {
  showdialogFormVisible.value = false
  fullpage.value.api.setAllowScrolling(true)
}
const fullpage = ref()
const options3 = {
  licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
  anchors: ['one', 'two', 'three', 'four', 'five'],
  // menu: '#menu',
  lockAnchors: true,
  navigation: false,//显示导航
  navigationPosition: 'right',
  verticalCentered: false,
  onLeave: (index, nextIndex) => {
    if (nextIndex.index === 0) {
      changeColor('changeColor', '')
    } else {
      changeColor('changeColor', true)
    }
  },
  afterRender: () => {
    setTimeout(() => {
      fullpage.value.api.moveTo(1, 0);
    }, 200)
  }
}
</script>

<style lang="scss">
@import '@/assets/css/style.css';

.ProductInfo {
  .fp-overflow {
    height: 100%;
  }

  .one-footer {
    position: inherit;
  }

  .section {
    height: 100%;
  }

  .one {
    background: url(../assets/image/banner1.png) no-repeat;
    background-size: 100% auto;
    position: relative;

    .one-img {
      position: absolute;
      bottom: 89px;
      right: 238px;
      height: 70%;
    }

    .phone {
      position: absolute;
      height: 60%;
      top: 24%;
      left: 25%;
    }

    .xiahua {
      position: absolute;
      height: 42px;
      bottom: 10%;
      right: 8%;
    }

    h3 {
      color: #fff;
      font-size: 48px;
      position: absolute;
      left: 8%;
      top: 23%;
      font-weight: 500;
      text-align: left;

      .one-text {
        font-size: 4.48vw;
        margin: 0;
        font-family: AlibabaPuHuiTi-Regular;
        font-weight: 400;
        color: #FFFFFF;
      }

      .one-text1 {
        font-size: 2.29vw;
        font-family: AlibabaPuHuiTi-Light;
        font-weight: 300;
        color: #FFFFFF;
        margin: 0 auto 2vw;
      }

      .more {
        width: 11.45vw;
        height: 3.12vw;
        background: #E50A33;
        border-radius:100px;
        opacity: 1;
        font-size: 1.45vw;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        color: #FFFFFF;
        display: inline-block;
        box-sizing: border-box;
        line-height: 3vw;
        text-align: center;
      }

      img {
        position: absolute;
        left: 0;
        top: -60px;
        width: 200px;
      }

      span {
        position: absolute;
        left: 0;
        bottom: -10px;
        width: 93px;
        height: 3px;
        background: #EE144A;
      }
    }

    p {
      color: #fff;
      font-size: 24px;
      position: absolute;
      left: 50%;
      top: 53%;
      opacity: .5;
      width: 384px;
      font-weight: 200;
      line-height: 40px;
    }
  }

  .two { 
    background-color: rgba(243, 243, 243, 1);
    z-index: 99;

    .two-img {
      position: absolute;
      bottom: 0;
      height: 66%;
      left: 0;
      right: 0;
      margin: auto;
    }

    h3 {
      font-size: 3vw;
      margin-top: 99px;
      font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 500;
      color: #000000;
      text-align: center;
      z-index: 1;
      margin-bottom: 0;
    }

    h3::after {
      width: 2.5vw;
      height: 2.5vw;
      content: "";
      position: absolute;
      border: 10px solid #E50A33;
      border-radius: 50%;
      margin-top: -0;
      margin-left: -1.8vw;
      z-index: -1;
    }

    .p {
      font-size: 3vw;
      font-family: AlibabaPuHuiTi-Light, AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 300;
      color: #000000;
      text-align: center;
      margin-top: 0px;
    }
  }

  .five {
    overflow: hidden;
    position: relative;
    background: #FFFFFF;

    .fRight {
      position: absolute;
      right: 15vw;
      top: 0;
      bottom: 0;
      margin: auto;
      height: 50%;
    }

    h3::before {
      width: 2.5vw;
      height: 2.5vw;
      content: "";
      position: absolute;
      border: 10px solid #E50A33;
      border-radius: 50%;
      margin-top: -1vw;
      margin-left: -1.8vw;
      z-index: -1;
    }

    h3 {
      font-size: 3.64vw;
      font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 500;
      color: #000000;
      position: absolute;
      top: 30%;
      left: 10%;
      z-index: 9;
      position: relative;
      z-index: 1;
      width: 50%;
    }

    .p {
      font-size: 1.14vw;
      font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 400;
      color: #333333;
      position: absolute;
      z-index: 9;
      left: 10%;
      margin-top: 49px;
      line-height: 36px;
      top: 45%;
    }
  }

  .six {
    background: linear-gradient(181deg, #F8F8F8 0%, #F7F7F7 100%);
    z-index: 99;

    .phone {
      position: absolute;
      height: 70%;
      top: 16%;
      left: 22%;
    }

    h4 {
      font-size: 45px;
      position: absolute;
      left: 48%;
      top: 30%;
      font-weight: 600;

      >div {
        position: relative;
        z-index: 9;
      }

      span {
        position: absolute;
        left: 0;
        bottom: -6px;
        width: 90px;
        height: 20px;
        background: linear-gradient(180deg, rgba(238, 20, 74, 0.1) 0%, rgba(234, 20, 53, 0.43) 54%, rgba(248, 39, 75, 0.79) 100%);
      }
    }

    p {
      color: #fff;
      font-size: 21px;
      position: absolute;
      left: 27%;
      top: 62%;
      opacity: .5;
      width: 384px;
      font-weight: 200;
      line-height: 40px;
    }
  }
}
</style>
